import { Box, Stack } from '@mui/material'
import React from 'react'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import AccessibilityIcon from '@mui/icons-material/Accessibility'
import { BoxWithLabel } from '../../../../../common/components/BoxWithLabel'
import { UsePatientEProfileReturn } from '../../hooks/usePatientEProfile'
import { PatientDetailsSectionHeader } from './PatientDetailsSectionHeader'
import { Loading } from '../../../../../common/components/Loading'

export const PatientLifeStyle: React.FC<UsePatientEProfileReturn> = ({
  patientDetails,
  isLoading,
}) => {
  const { t } = useTranslation()

  return (
    <Box bgcolor={'success.light'} py={2} borderRadius={3}>
      <PatientDetailsSectionHeader
        icon={<AccessibilityIcon fontSize="large" />}
        title={t('doctor:patientProfile.lifestyle.title')}
        extraHeaderInfo={`${t('doctor:patientProfile.lastUpdated')}: ${t(
          'common:intlDateFormattedLongMonth',
          {
            date: patientDetails.lifestyle.lastUpdated,
          }
        )}`}
      />

      {isLoading ? (
        <Loading />
      ) : (
        <Stack px={3}>
          <table>
            <thead>
              <tr>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <BoxWithLabel
                    label={t('doctor:patientProfile.lifestyle.alcohol')}
                  >
                    {patientDetails.lifestyle.alcohol ?? '-'}
                  </BoxWithLabel>
                </td>
                <td>
                  <BoxWithLabel
                    label={t(
                      'doctor:patientProfile.lifestyle.extraMedicationInfo'
                    )}
                  >
                    {patientDetails.lifestyle.medicationInfo ?? '-'}
                  </BoxWithLabel>
                </td>
              </tr>
              <tr>
                <td>
                  <BoxWithLabel
                    label={t('doctor:patientProfile.lifestyle.health')}
                  >
                    {patientDetails.lifestyle.healthHabits ?? '-'}
                  </BoxWithLabel>
                </td>
                <td>
                  <BoxWithLabel
                    label={t('doctor:patientProfile.lifestyle.diet')}
                  >
                    {patientDetails.lifestyle.diet ?? '-'}
                  </BoxWithLabel>
                </td>
              </tr>
              <tr>
                <td>
                  <BoxWithLabel
                    label={t('doctor:patientProfile.lifestyle.smoking')}
                  >
                    {patientDetails.lifestyle.smoking ?? '-'}
                  </BoxWithLabel>
                </td>
                <td>
                  <BoxWithLabel
                    label={t('doctor:patientProfile.lifestyle.work')}
                  >
                    {patientDetails.lifestyle.typeOfWork ?? '-'}
                  </BoxWithLabel>
                </td>
              </tr>
              <tr>
                <td>
                  <BoxWithLabel
                    label={t('doctor:patientProfile.lifestyle.toxicImpacts')}
                  >
                    {patientDetails.lifestyle.toxicImpacts ?? '-'}
                  </BoxWithLabel>
                </td>
                <td>
                  <BoxWithLabel
                    label={t('doctor:patientProfile.lifestyle.sports')}
                  >
                    {patientDetails.lifestyle.exercise ?? '-'}
                  </BoxWithLabel>
                </td>
              </tr>
            </tbody>
          </table>
        </Stack>
      )}
    </Box>
  )
}
